import { styled as e, Button as i } from "@mui/material";
import { DEFAULT_ANIMATE_DURATION as t } from "../../temp-lib/constants/layout.js";
import { forwardRef as p } from "react";
import { jsx as m } from "react/jsx-runtime";
const s = e(i)`
  background-color: #27282a;
  border-radius: 4px;
  padding: 15px 25px;
  transition: background-color ${t}ms,
    filter ${t}ms;
  font-weight: 300;
  font-size: 16px;
  color: white;
  text-transform: none;
  &:hover {
    background-color: #1d66bf;
    filter: brightness(1.2);
  }
  ${(o) => o.theme.breakpoints.up("res1024")} {
    min-width: 160px;
  }
`, l = p(function(r, n) {
  return /* @__PURE__ */ m(s, {
    ...r,
    ref: n
  });
});
export {
  l as default
};
//# sourceMappingURL=ApeironSimpleButton.js.map
